module.exports = __webpack_public_path__ + "static/img/1.c6f4b737.png";